import { Clock } from "lucide-react";
import { useRecent } from "@/api/hooks";
import { DriveView, PageTitle } from "./DriveView";
import { EmptyState } from "./EmptyState";

/** Files the user recently opened, previewed or downloaded. */
export function RecentPage() {
    const recent = useRecent(50);
    return (
        <DriveView
            variant="recent"
            label="Recent files"
            title={<PageTitle icon={Clock}>Recent</PageTitle>}
            query={recent}
            resetKey="recent"
            emptyState={
                <EmptyState icon={Clock} title="No recent files" description="Files you open, preview or download show up here." />
            }
        />
    );
}
